import { render, staticRenderFns } from "./Farms.vue?vue&type=template&id=3d07d036&"
import script from "./Farms.vue?vue&type=script&lang=ts&"
export * from "./Farms.vue?vue&type=script&lang=ts&"
import style0 from "./Farms.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QBtn,QBanner,QBtnToggle,QTooltip});
